import { PhoneCall, Tag, MoonStar, MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WA_LINK } from "../../lib/site";
import { useLang } from "../../lib/i18n";

const POINT_ICONS = [PhoneCall, Tag, MoonStar];

export const WhyUs = () => {
    const { t } = useLang();
    return (
    <section id="waarom" data-testid="why-section" className="relative py-24 sm:py-32">
        <div className="container-x">
            <SectionHeading
                num="03"
                eyebrow={t.why.eyebrow}
                title={t.why.title}
                text={t.why.text}
            />
            <div className="mt-14 grid gap-5 md:grid-cols-3">
                {t.why.points.map((point, i) => {
                    const Icon = POINT_ICONS[i];
                    return (
                    <Reveal key={point.title} delay={0.08 * i}>
                        <div
                            data-testid={`why-card-${i}`}
                            className="card-lift h-full rounded-2xl border border-white/8 bg-night-850/80 p-8"
                        >
                            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-amber-400/10 text-amber-400">
                                <Icon size={24} />
                            </span>
                            <h3 className="mt-6 font-display font-wide text-xl font-bold uppercase text-white">
                                {point.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400">{point.text}</p>
                        </div>
                    </Reveal>
                    );
                })}
            </div>
            <Reveal delay={0.2}>
                <div className="mt-12 flex flex-col items-center justify-between gap-6 rounded-2xl border border-amber-400/25 bg-gradient-to-r from-amber-400/10 via-night-850 to-night-850 p-8 sm:flex-row sm:p-10">
                    <p className="max-w-xl text-center text-base text-slate-300 sm:text-left sm:text-lg">
                        {t.why.banner}
                    </p>
                    <a
                        href={WA_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="why-whatsapp-cta"
                        className="btn-amber shrink-0 px-7 py-4 text-base"
                    >
                        <MessageCircle size={18} /> {t.why.bannerCta}
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
    );
};
